import logo from 'images/communities/Alabama/artlook-alabama-logo.svg'
import secondaryLogo from 'images/communities/Alabama/logo.png'
import thirdLogo from 'images/communities/Alabama/secondary-community-logo.png'
import dashboardHeaderImage from 'images/communities/Alabama/banner.jpg'
import mapHeaderImage from 'images/communities/Alabama/landing.jpg'
import loginBackgroundImg from 'images/communities/Alabama/background-image.jpg'
import favicon from 'images/communities/Alabama/favicon.png'
import homeLogo from 'images/home/community-logos/alabama.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/alabama-video-button-image.png'

const config = {
  subdomain: 'alabama',
  name: 'Alabama',
  position: 8,
  partnerSupportEmail: 'artlookal@alartsalliance.org',
  schoolSupportEmail: 'ArtlookAL@alartsalliance.org',
  artistSupportEmail: 'ArtlookAL@alartsalliance.org',
  stylesheet: 'alabama.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://www.alabamaachieves.org/',
  secondaryOrganizationUrl: 'https://www.alartsalliance.org/artlookalabama',
  faqUrl:
    'https://drive.google.com/file/d/1oFq8Wf_Y5uRbCDP0gDKUGmzROm-dIE4Y/view?usp=sharing',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  surveyCompletionEnabled: false,
  showRecentLoginOnPublicPage: false,
  portalSignInEnabled: true,
  partnerProgramsEnabled: true,
  googleLoginEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  partnerRegisterEnabled: true,
  showHomeRegistrationLink: true,
  id: 44,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: true,
  registerEnabled: true,
  provideOwnPrograms: true,
}

// ----- REGISTER -----
config.organizationRegister = {
  fields: {
    organizationName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    disciplineTypes: {
      visible: true,
      required: true,
    },
    ein: {
      visible: false,
      required: false,
    },
    website: {
      visible: false,
      required: false,
    },
  },
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: true,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory'],
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 32.360543, lng: -86.255659 },
    radius: 250, //in miles
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'alabama-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "Alabama's homepage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Alabama State Department of Education',
  },
  secondaryFooterLogo: {
    src: secondaryLogo,
    alt: 'Alabama Arts Alliance',
    link: config.organizationUrl,
  },
  thirdSideBySideLogo: {
    src: thirdLogo,
    alt: 'Alabama Arts Alliance',
    link: config.secondaryOrganizationUrl,
  },
  firstSubLogo: {
    src: secondaryLogo,
    alt: 'Alabama Arts Alliance',
    link: config.organizationUrl,
  },
  secondSubLogo: {
    src: thirdLogo,
    alt: 'Alabama Arts Alliance',
    link: config.secondaryOrganizationUrl,
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: mapHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: Increasing Arts Education in Alabama Public Schools',
    searchHeader: 'Find Schools & Partners in Alabama',
    welcomeSearchHeader: 'Explore Arts Education in Alabama',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Alabama</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
           artlook<sup>®</sup> ${config.name} is a free, online platform that connects educators and young people 
           across the state with meaningful, relevant arts learning experiences. Developed in close collaboration with 
           Alabama’s arts educators, artlook®Alabama maps out everything from which art teachers and arts partners are 
           in specific schools to the types of arts programming, coursework, and instructional minutes available.  
          </p>
          <p>
            This easy-to-use hub serves as your one-stop source for comprehensive information on arts education 
            throughout ${config.name}. With thousands of data points, artlook® empowers educators, administrators, and 
            policymakers to make informed decisions about expanding arts opportunities in Alabama’s public schools. 
          </p>
        </div>
        <div class="column-right">
          <p>
            Originally developed by Ingenuity in Chicago, artlook<sup>®</sup>  was adapted for ${config.name} through 
            support from the Alabama State Department of Education. The platform is maintained in partnership with the 
            Alabama Arts Alliance, offering an up-to-date directory of the people, places, and programs shaping arts 
            education statewide. Explore artlook®Alabama today and help advance access, quality, and equity in arts 
            education – for Every Child, Every Chance, Every Day. 
          <p>
            We welcome new arts partners! To learn more about eligibility and how to join the map, contact us at 
            <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Schools`,
      text: `
        <p>
          Are you an arts organization or teaching artist? Use the map to find schools seeking the kinds of programs you 
          offer - then reach out and make a connection!
        </p>
        <p>
          Are you a parent searching for a school that nurtures your child’s creativity? Explore schools offering strong 
          arts programs or specific disciplines that align with your child’s interests.
        </p>
      `,
    },
    findProgramsCard: {
      title: `Find Arts Programs & Organizations`,
      text: `
        <p>
          Are you a school looking for arts programs, partnerships, or resources?
        </p>
        <p>
          Use the map to find arts organizations that offer exactly what you need. New arts education partners are ready to 
          connect and collaborate!
        </p>
      `,
    },
    findDataCard: {
      title: `Find Data`,
      text: `
        <p>
          Passionate about strengthening arts education in ${config.name}?
        </p>
        <p>
          Connect with us at 
          <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>. 
          We offer data, programming, and partnership opportunities designed to expand and enrich creative learning 
          experiences for students across our region.
        </p>
      `,
    },
    justExploreCard: {
      title: `Just Explore`,
      text: `
        <p>
          The artlook<sup>®</sup> ${config.name} Map gives you the clearest picture of arts education in ${config.name}: 
          what’s happening, what’s missing, and where the spotlight still needs to shine
        </p>
      `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This FREE publicly available and searchable map is the only one of its kind in Alabama! It captures essential 
        information about arts education from local schools, arts organizations, and teaching artists.       
      </p>
      <p>
        The Search function lets you explore arts education programs and resources available to students - both in 
        schools and through community partners across Alabama. The Map and Directory offer an up-to-date snapshot of 
        where arts education is happening and how to get involved. You’ll also find contact information to connect 
        directly with schools and arts organizations.
      </p>
      <p>
        EXPLORE & CONNECT to help bring more arts to more students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/CsLD5i-Nt0A?si=fafKBRl3bk7Vr_Np&amp;controls=0',
      iframeTitle: 'Alabama artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline:
    'Bridging the gap: Providing opportunities for better access, equity and quality arts education for Every Child, Every Chance, Every Day',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Alabama</em> is YOUR gallery for arts education data</h3>
        <p>
          artlook<sup>®</sup> Alabama is the only platform of its kind that combines data from Alabama public schools and arts education program providers (like you!). The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in Alabama.
        </p>
        <p>
          To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.
        </p>
        <p>
          If you have any questions or need assistance, please contact the Alabama Arts Alliance at <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener">${config.partnerSupportEmail}</a>.
        </p>
        <p>
          <em>Arts partners (organizations) must comply with all policies and practices required by LEAs and schools regarding outside visitors on campus. Arts organizations are responsible for all individual artists they employ who work in schools. A background check is required for individual artists who intend to register as an individual arts partner. Individual arts partners will receive an email with a link to complete the process. Profile pages will not be approved until the results are verified.</em>
        </p>
        <p>
          <em>If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener">${config.partnerSupportEmail}</a></em>
        </p>
      `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Alabama</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Alabama</em> is the only platform of its kind that combines data from Alabama public schools (like you!) and arts education program providers. The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in Alabama.
        </p>
        <p>
          <strong>
            To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.
          </strong>
        </p>
        <p>If you have any questions or need assistance, please contact the Alabama Arts Alliance at <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>
      `,
    },
  },
  survey: {
    getStarted: `<h2>Welcome to the {{ surveySchoolYearNumber }} Alabama State Department of Education Creative Schools Survey!</h2>
    <p>Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e. arts organizations), and how your school budgets and plans for the arts.</p>
    <p>As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting.</p>
    <p>Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions!</p>`,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day. Certified Arts Teachers teaching non arts courses should not be counted in this section even if they are using arts to enhance their classroom instruction.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status for the entire school year. If a teacher was part-time for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    districtSpending: {
      question: `How much funding did your school dedicate to arts education supplies, materials, and programs in {{surveySchoolYearNumber}}? Please only include funding from school and district sources, but do not include teacher salaries or capital expenses.`,
      description: `Only include funding from school and district sources, but do not include teacher salaries or capital expenses.`,
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: false,
      },
    },
    partnershipQuestion: {
      additionalTipsModal: `
        <p>
          Some arts partners may have already reported their partnerships with us, and those will appear here.
        </p>
        <p>
          If you cannot find a partner from our search box, new partnerships can be created by arts liaisons.
        </p>
        <p>
          Please give us as much contact information as possible for teaching artists so that we can locate them and reach out to get them added to artlook<sup>®</sup>.
        </p>
        <p>
          The primary focus of this section is to track external arts partnerships. If a teacher at your school or the school itself is providing additional arts programming before or after school, please select 'School-Provided Arts Programming' as the name of the partner and choose Out-of-School Time (OST) as the program type. You may select more than one program type, but you may only enter 'School-Provided Arts Programming' once.
        </p>
      `,
    },
    courses: {
      coursesNote: `
        <p>
          <strong>Note on course names and numbers:</strong> If the art course is not in PowerSchool and hence does not have an "official" name and number, please use the following naming convention for course names AND numbers (use the same name for both)-:“[Discipline] – Grade [X].” 
        </p>
        <p>
          For example: “Music – Grade 2” or “Visual Arts – KG" when adding courses."
        </p>
        <p>
          <strong>Note on courses:</strong> An arts course meets the following criteria: (1) it is offered to students during the school day, (2) it is categorized as an arts course rather than another content area (e.g., math, science), and (3) it is taught by a credited arts instructor.
        </p>
      `,
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.GENERAL,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
